import styled from 'styled-components';

export const ContentAgreementsModal = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px 2%;
    button: {
        cursor: pointer;
    }
`

export const ContentAgreementsInfo = styled.div`
    margin-top: 50px;
    width: 100%;
    border-radius: 15px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    overflow-y: scroll;
    div {
     margin-bottom: 15px;
    }
    padding: 30px 0;
`

export const ContentButton = styled.div`
margin-top: 15px;
width: 130px;
height: 30px;
`